import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

export default function HomeTileCard({ imageSrc, title, subtitle, loading = false, width = 120 }) {
  return (
    <Box sx={{ width }}>
      <Box sx={{ width, height: width, position: 'relative', borderRadius: 1, overflow: 'hidden', backgroundColor: 'rgba(255,255,255,0.05)' }}>
        {loading || !imageSrc ? (
          <Skeleton variant="rectangular" sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
        ) : (
          <img src={imageSrc} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
      </Box>
      <Box sx={{ marginTop: 1 }}>
        {loading ? (
          <>
            <Skeleton variant="text" width="80%" height={20} />
            <Skeleton variant="text" width="60%" height={16} />
          </>
        ) : (
          <>
            <Typography variant="body2" noWrap>{title}</Typography>
            <Typography variant="caption" sx={{ color: '#999' }} noWrap display="block">{subtitle}</Typography>
          </>
        )}
      </Box>
    </Box>
  );
}
